
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import PropositionForm from '@/components/forms/PropositionForm.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')
const propositionModule = namespace('proposition')
const refModule = namespace('ref')
const uiModule = namespace('ui')

@Component({
  components: {
    BaseCardContainer,
    PropositionForm
  }
})
export default class ProspectContactUpdate extends Vue {
  @propositionModule.Getter('propositionGetter') proposition: any
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @propositionModule.Action('getPropositionByIdAction') getPropositionById: any
  @propositionModule.Action('updatePropositionAction') updateProposition: any
  @refModule.Getter('refGetter') refObject: any
  @refModule.Action('getRefAction') getRef: any
  @uiModule.Action('resetIsEditAction') resetIsEdit: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  @Watch('$route.params.propositionId', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getPropositionById(newVal)
  }

  mounted() {
    if (!this.refObject.offre) {
      this.getRef('offre')
    }
    if (!this.refObject.typeRemise) {
      this.getRef('typeRemise')
    }
    this.getPropositionById(this.$route.params.propositionId)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.updateProposition({
      id: this.$route.params.propositionId,
      formParams: data
    }).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.resetIsEdit()
      this.$router.push({name: 'prospectProposition', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.push({name: 'prospectProposition', params: {id: this.$route.params.id}})
  }
}
